class ProductSwiperBgImage extends HTMLElement {
    constructor() {
        super();
        this._swiperInstance = null;
    }

    connectedCallback() {
        const swiperContainer = this.querySelector('.swiper');
        const nextButton = this.querySelector('.swiper-button-next');
        const prevButton = this.querySelector('.swiper-button-prev');
        this._swiperInstance = new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            // spaceBetween: 37,
            navigation: {
                nextEl: nextButton || null,
                prevEl: prevButton || null,
            },
            // breakpoints: {
            //     1701: {
            //         slidesPerView: 4,
            //         spaceBetween: 37,
            //     },
            //     1024: {
            //         slidesPerView: 3.3,
            //         spaceBetween: 37,
            //     },
            //     749: {
            //         slidesPerView: 2.3,
            //         spaceBetween: 20,
            //     },
            //     300: {
            //         slidesPerView: 2.05,
            //         spaceBetween: 8,
            //     }
            // },
        });
    }

}

customElements.define('product-swiper-bg-image', ProductSwiperBgImage);